import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {Store} from '@ngrx/store';
import * as SummaryActions from './summary.actions';
import {loadResearchPapers} from '../../../research/services/research-paper/research-paper.actions';


export const summaryListResolver: ResolveFn<boolean> = (route, state) => {
  const store = inject(Store);
  const projectId = route.parent!.parent!.paramMap.get('projectId');
  if (!projectId) {
    return false;
  }
  store.dispatch(SummaryActions.loadProjectSummaries({projectId: +projectId!}));
  store.dispatch(SummaryActions.checkGenerateProjectSummaryStart({projectId: +projectId!}));

  return true;
};


export const summaryDetailResolver: ResolveFn<boolean> = (route, state) => {
  const store = inject(Store);
  const projectId = route.parent!.parent!.paramMap.get('projectId');
  if (!projectId) {
    return false;
  }
  const summaryId = +route.paramMap.get('summaryId')!;

  store.dispatch(SummaryActions.loadProjectSummary({
    projectId: +projectId!,
    summaryId: summaryId
  }));
  store.dispatch(loadResearchPapers({projectId: +projectId!}));

  return true;
};
